import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AuthService from "../../services/auth.service";
import CommonOtp from "../../components/otp-pre-login";

export default function ForgotUserNameOTP(data = {}) {
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);

  useEffect(() => {}, []);

  const onConfirm = useCallback(
    async (values) => {
      try {
        const response = await AuthService.forgotUsernameConfirm({
          ...values,
          ...data.data,
        });
        if (response.status === 200) {
          setMessage(response.data["message"]);
          setSuccessVisible(true);
        }
      } catch (error) {
        setOtp("");
      }
    },
    [data.data]
  );

  const handleResendOtp = useCallback(async () => {
    setOtp("");
    const response = await AuthService.forgotUsernameVerify(data.data);
    if (response.status === 200) {
    }
  }, [data.data]);

  return (
    <>
      <CommonOtp
        otp={otp}
        setOtp={setOtp}
        type="TRANSACTION"
        onConfirm={() => onConfirm({ ...data.data, otp: otp })}
        handleResendOtp={() => handleResendOtp()}
        cancelTransaction={() => {
          navigate("/login");
        }}
        verifyDetails={data.data}
        successVisible={successVisible}
        message={message}
        routingURL={"/login"}
      />
    </>
  );
}
